import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {EXPIRATION_EXERCISE_ASSIGNMENT_5} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const ExpirationExerciseAssignment5 = "tfExpirationExerciseAssignment5Question";

export function expirationExerciseAssignment5() {
    return {
        templateUrl: "app/quiz/fxe/questions/ExpirationExerciseAssignment5.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: ExpirationExerciseAssignment5Controller
    };
}

export class ExpirationExerciseAssignment5Controller extends FxeQuizQuestionController {
    public config = EXPIRATION_EXERCISE_ASSIGNMENT_5;
}
